/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pleaseenteryouremail3Inputs */

const en_pleaseenteryouremail3 = /** @type {(inputs: Pleaseenteryouremail3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter your email`)
};

const de_pleaseenteryouremail3 = /** @type {(inputs: Pleaseenteryouremail3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte gib deine E-Mail-Adresse ein.`)
};

/**
* | output |
* | --- |
* | "Please enter your email" |
*
* @param {Pleaseenteryouremail3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pleaseenteryouremail3 = /** @type {((inputs?: Pleaseenteryouremail3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pleaseenteryouremail3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pleaseenteryouremail3(inputs)
	return de_pleaseenteryouremail3(inputs)
});
export { pleaseenteryouremail3 as "pleaseEnterYourEmail" }